import { IWebsiteWelcomeMessage } from '../../api-response/auth/website-builder';
import { WebsiteBuilderItemBase } from './website-builder-item-base';

export class WebsiteBuilderItemWelcomeMessage extends WebsiteBuilderItemBase {
    name = 'Welcome Message';
    navName = 'Welcome Message';
    navLink = 'welcomeMessage';
    isShowInMenu = false;
    isHomePagePart = true;

    headline: string = '';
    text: string = '';

    get isDisable(): boolean {
        return !(this.headline || this.text);
    }

    set value(item: IWebsiteWelcomeMessage) {
        this.isPresent = item.status;
        this.headline = item.headlineText || '';
        this.text = item.mainText || '';
        this.priority = item.priority;
    }

    get value(): IWebsiteWelcomeMessage {
        return {
            headlineText: this.headline,
            mainText: this.text,
            status: this.isPresent,
            priority: this.priority
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-welcome-message.ts